import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const version = {
  getVersion: lazyModuleMethod(() => import('./getVersion'), 'default'),
}
